import CalculatorService from './calculator.service'

export default angular.module('app.services.calculator', [])
  .service('calculatorService', CalculatorService)
  .run(function(calculatorService) {
    // This instantiates the service early to ensure event
    // listeners are set up before components are loaded
  })
